const MAX_ITEMS = 10;

export function getTopGeographiesByRevenue(items = []) {
  return [...items]
    .map(item => ({
      ...item,
      metrics: {
        'Ad Requests': Number(item.metrics?.['Ad Requests'] ?? 0),
        Impressions: Number(item.metrics?.Impressions ?? 0),
        Clicks: Number(item.metrics?.Clicks ?? 0),
        Revenue: Number(item.metrics?.Revenue ?? 0),
      },
    }))
    .sort((left, right) => right.metrics.Revenue - left.metrics.Revenue)
    .slice(0, MAX_ITEMS);
}

export function getCountryGeography(country, selectedLevel) {
  if (!country) {
    return [];
  }

  if (selectedLevel === 'city') {
    return getTopGeographiesByRevenue(country.cities ?? []);
  }

  return getTopGeographiesByRevenue(country.regions ?? []);
}

export const geographyLevel = {
  region: 'region',
  city: 'city',
};
